
import { defineComponent, onMounted, inject, reactive, ref } from "vue";
import { User, Key } from "@element-plus/icons-vue";
import type { FormInstance, FormRules } from "element-plus";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { errManager } from "@/core/config/Tools";
import { asideTheme, themeLightLogo, themeDarkLogo, } from "@/core/helpers/config";
//services
import authService from "@/core/services/AuthService";
import PublicService from "@/core/services/PublicService";

export default defineComponent({
    name: "sign-in",
    setup() {
        const store = useStore();
        const route = useRoute();
        const router = useRouter();
        const loading = ref(false)
        const dataCompany = inject<any>('dataCompany');
        const ruleFormRef = ref<FormInstance>();
        const submitButton = ref<HTMLButtonElement | null>(null);
        const emailSupport = ref(process.env.VUE_APP_EMAIL)
        const repo = ref(process.env.VUE_APP_REPO);
        

        const form = reactive({
            username: "",
            password: "",
            company: null,
        });

        const rules = reactive<FormRules>({
            username: [{
                required: true,
                message: "Ingrese nombre de usuario",
                trigger: ["blur", "change"],
            },],
            password: [{
                required: true,
                message: "Ingrese contraseña",
                trigger: ["blur", "change"],
            },],
        });


        //Form submit function
        const onSubmitLogin = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;

            await formEl.validate((valid, fields) => {
                if (valid) onLogin();
            });
        };

        const onLogin = async () => {
            store.dispatch(Actions.LOGOUT);

            if (submitButton.value) {
                submitButton.value!.disabled = true;
                submitButton.value.setAttribute("data-kt-indicator", "on");
            }

            await authService.logIn(form)
                .then(({ data }) => {
                    submitButton.value?.removeAttribute("data-kt-indicator");
                    submitButton.value!.disabled = false;
                    if (data.status) {
                        store.dispatch(Actions.LOGIN, data)
                        router.push({
                            name: data.redirect
                        });
                    }
                }).catch(({ response }) => {
                    submitButton.value?.removeAttribute("data-kt-indicator");
                    submitButton.value!.disabled = false;
                    errManager(response)
                })
        };

        const getDataCompany = async () => {
            loading.value = true
            await PublicService.getCompany(route.params.company)
                .then((res) => {
                    dataCompany.value = res.data
                    form.company = res.data?.alias
                    loading.value = false
                }).catch(({ response }) => {
                    loading.value = false
                })
        }

        onMounted(() => {
            getDataCompany()
        })

        return {
            loading,
            dataCompany,
            asideTheme,
            themeLightLogo,
            themeDarkLogo,
            emailSupport,
            repo,
            User,
            Key,
            form,
            rules,
            ruleFormRef,
            onSubmitLogin,
            submitButton,
        };
    },
});
